import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[], is_ecommerce: boolean) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/transition/?ecommerce=${is_ecommerce}&filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}`;
        return HttpClient.instance().get(url);
    },
    async createNewItems(dataRequest: any) {
        const url = `/api/transition/`;
        return HttpClient.instance().put(url, dataRequest);
    },
    async getPrintDetail(id: number) {
        const url = `/api/order_transactions/print/${id}`;
        return await HttpClient.instance().get(url);
    },
    async getDetail(id: string) {
        const url = `/api/transition/${id}`;
        return HttpClient.instance().get(url);
    },
    async updateDetail(id: number, dataRequest: any) {
        const url = `/api/transition/${id}`;
        return HttpClient.instance().post(url, dataRequest);
    },
    getOfficialList(page: number, rowsPerPage: number, status: string = '', search: string = '') {
        let url = `/api/official_tracking/?page=${page}&rowsPerPage=${rowsPerPage}`;
        if (status) url += `&status=${encodeURIComponent(status)}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return HttpClient.instance().get(url);
    },
};
